/**
 * Buy-now for product pages. A click on the product form's checkout button
 * opens a cart permalink (/cart/<variant>:<qty>), which creates a fresh cart
 * for that script and sends the buyer straight to checkout. Without
 * JavaScript, the form's native fallback adds the script and opens the cart page.
 * The VIP add-on stops this handler when it adds two products itself.
 */
document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-buy-now-form]')) return;

  const submitter = event.submitter;
  if (submitter instanceof HTMLElement && submitter.getAttribute('name') !== 'checkout') return;
  if (submitter?.getAttribute('aria-disabled') === 'true') return;

  const variantId = String(new FormData(form).get('id') || '').trim();
  if (!/^\d+$/.test(variantId)) return;

  const quantityValue = Number.parseInt(String(new FormData(form).get('quantity') || '1'), 10);
  const quantity = Number.isFinite(quantityValue) && quantityValue > 0 ? quantityValue : 1;

  event.preventDefault();
  submitter?.setAttribute('aria-disabled', 'true');
  submitter?.classList.add('opacity-50', 'cursor-wait');

  const root = window.Shopify?.routes?.root || '/';
  window.location.assign(`${root}cart/${variantId}:${quantity}`);
});

// A buyer returning with the back button gets an active button again.
window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-buy-now-form] [name="checkout"][aria-disabled="true"]').forEach((button) => {
    button.removeAttribute('aria-disabled');
    button.classList.remove('opacity-50', 'cursor-wait');
  });
});
